import React from "react";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { makeStyles } from "@mui/styles";
import FilterListIcon from "@mui/icons-material/FilterList";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

export default function CustomFilterButton(props) {
  const classes = useStyles();

  return (
    <Button
      style={{
        height: props.size ? props.size : "32px",
        width: props.size ? props.size : "32px",
        padding: "0px",
        margin: "0px",
        marginLeft: "5px",
        backgroundColor: "#3E8FC6",
      }}
      className={classes.actionButton}
      onClick={props.onClick}
    >
      <FilterListIcon />
    </Button>
  );
}
